import { login, logout, getMenus } from '@/api/auth'

const state = {
  token: localStorage.getItem('token') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
  menus: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus
  },
  CLEAR_TOKEN: (state) => {
    state.token = ''
    state.userInfo = {}
    state.menus = []
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      const loginData = {
        username: userInfo.username,
        password: userInfo.password,
        captchaId: userInfo.captchaId,
        captchaCode: userInfo.captchaCode
      }
      login(loginData).then(response => {
        const { token, user } = response.data
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', user)
        getMenus().then(res => {
          commit('SET_MENUS', res.data || [])
          resolve()
        }).catch(() => {
          commit('SET_MENUS', [])
          resolve()
        })
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMenus({ commit }) {
    return getMenus().then(res => {
      commit('SET_MENUS', res.data || [])
      return res.data
    }).catch(() => {
      commit('SET_MENUS', [])
      return []
    })
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      logout().then(() => {
        commit('CLEAR_TOKEN')
        resolve()
      }).catch(() => {
        commit('CLEAR_TOKEN')
        resolve()
      })
    })
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  menus: state => state.menus
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
